import { Decimal, toDecimal } from './decimal.js';

/** Minimum EP sell quantity (PWA listing). */
export const EP_TRADE_MIN_ORDER_EP = 6;
/** Maximum EP sell quantity (PWA listing). */
export const EP_TRADE_MAX_ORDER_EP = 1310;
/**
 * Legacy buyer-fee divisor: buyer_fee = amount × (2 × listing_fee) / 131.
 * Must stay 131 for parity with historic settlements — do not reuse as min order.
 */
export const EP_TRADE_FEE_BASE_EP = 131;

export type EpTradeAmounts = {
  seller_lock_ep: string;
  buyer_settle_ep: string;
  buyer_fee_ep: string;
  listing_fee_ep: string;
};

function roundEpAmount(value: ReturnType<typeof toDecimal>): string {
  return value.toDecimalPlaces(3, Decimal.ROUND_HALF_UP).toFixed(3);
}

export function computeEpTradeAmounts(amountEp: string, listingFeeEp: number): EpTradeAmounts {
  const amount = toDecimal(amountEp);
  const listingFee = toDecimal(String(listingFeeEp));
  const sellerLock = amount.add(listingFee);
  const buyerFee = amount.mul(listingFee.mul(2)).div(EP_TRADE_FEE_BASE_EP);
  const buyerSettle = amount.sub(buyerFee);

  return {
    listing_fee_ep: roundEpAmount(listingFee),
    seller_lock_ep: roundEpAmount(sellerLock),
    buyer_fee_ep: roundEpAmount(buyerFee),
    buyer_settle_ep: roundEpAmount(buyerSettle),
  };
}

export function resolveStoredEpTradeAmounts(order: {
  amount_ep: string;
  seller_lock_ep?: string | null;
  buyer_settle_ep?: string | null;
}): EpTradeAmounts {
  const amount = order.amount_ep;
  if (order.seller_lock_ep && order.buyer_settle_ep) {
    const sellerLock = toDecimal(order.seller_lock_ep);
    const buyerSettle = toDecimal(order.buyer_settle_ep);
    const amountDec = toDecimal(amount);
    return {
      listing_fee_ep: roundEpAmount(sellerLock.sub(amountDec)),
      seller_lock_ep: order.seller_lock_ep,
      buyer_settle_ep: order.buyer_settle_ep,
      buyer_fee_ep: roundEpAmount(amountDec.sub(buyerSettle)),
    };
  }
  return computeEpTradeAmounts(amount, 5);
}
